// #2121-spec-kits
import React from 'react';
import { translate } from 'react-translate';
import PracticeOrdersList from 'components/PracticeOrders/PracticeOrdersList';

const PracticeOrders = () => <PracticeOrdersList />;

export default translate('practice-orders')(PracticeOrders);
